import { useCallback, useEffect, useState } from "react";

import { connect } from "react-redux";
import { PageWrap, ContentContainer } from "../components/Layout";
import { Heading } from "../components/Heading";
import { TabContent } from "components/Tabs/styled";
import Loader from "react-spinners/BeatLoader";
import { shareProfile } from "actions/authActions";
import { navigate } from "@reach/router";
import { useDispatch } from "react-redux";
import { showToast } from "utils/helpers";
import { useCurrentUser } from "hooks/auth";
import { useReferralToken } from "newui/features/Auth/hooks/useReferralToken";
import { logIfDebug } from "utils/logging";
import { useAuthContext } from "newui/features/Auth/context/AuthContextProvider";

const ShareProfileComponent = (props) => {
	const [loading, setLoading] = useState(true);
	const queryParams = new URLSearchParams(window.location.search);
	const { isGuest } = useCurrentUser();
	const dispatch = useDispatch();
	const { referralToken, clearReferralToken } = useReferralToken();
	const { currentUserHomePage } = useAuthContext();

	const handleShareProfile = useCallback(async () => {
		try {

			if (!referralToken?.tokenValue) {
				navigate(currentUserHomePage);
				return;
			}

			const result = await props.shareProfile(referralToken.tokenValue);

			// const result = { success: false };
			if (result.success) {
				const sharedCompanyId = referralToken?.metadata?.companyId ?? result.data?.companyId;

				showToast(result?.message, "Success", true);
				if (result?.message === "You are already connected to this profile!") {
					navigate(currentUserHomePage);
				} else if (isGuest && sharedCompanyId) {
					navigate(`/company/${sharedCompanyId}/projects`);
				} else if (isGuest) {
					navigate(`/account/rfx`);
				} else {
					navigate(`/company/${result?.data?.companyId}/projects`);
				}
			} else {
				showToast(result?.errors?.invitetoken[0] || result?.message, "Error");
				navigate(currentUserHomePage);
			}
		} catch (error) {
			logIfDebug(error);
		} finally {
			setLoading(false);
			clearReferralToken();
		}
	}, [props, clearReferralToken, referralToken, isGuest, currentUserHomePage]);

	useEffect(() => {
		if (loading) {
			handleShareProfile();
		}
	}, [loading, handleShareProfile]);

	return (
		<PageWrap>
			<TabContent>
				<ContentContainer>
					<Heading size="xl">Share Profile</Heading>
					<>
						<p>Connecting profile to your account...</p>
						<Loader />
					</>
				</ContentContainer>
			</TabContent>
		</PageWrap>
	);
};

const mapStateToProps = (state) => {
	return {
		user: state.auth.user,
		companyId: state.search.activeCompany.id,
	};
};

export const ShareProfile = connect(mapStateToProps, {
	shareProfile,
})(ShareProfileComponent);
